import React from 'react';
import PropTypes from 'prop-types';

import TruncatableText from '../../../../Elements/TruncatableText/TruncatableText';
import EditButton from '../EditButton/EditButton';
import { personalHistoryShape } from '../../../../Includes/userProps';
import { PageContext } from '../../../../../contexts/ContextCreator';
import {
    buildDefaultSingleEducationState,
    getEducationId,
} from '../../../../Modals/Flows/SingleEducation/constants';

import { singleEducationFlowType } from '../../../../Modals/Flows/SingleEducation/SingleEducation';
import { capitalize } from '../../../../../utilities/helperFunctions';

import './PersonalHistory.scss';
import {
    buildDefaultSingleExperienceState,
    getExperienceId,
} from '../../../../Modals/Flows/SingleExperience/constants';
import { singleExperienceFlowType } from '../../../../Modals/Flows/SingleExperience/SingleExperience';

const findHistoryById = (id, list) => list.find((item) => item.id === id);

export default class PersonalHistory extends React.PureComponent {
    constructor(props) {
        super(props);
        this.baseClassName =
            'component-Users-UserProfile-Modules-PersonalHistory';
        this.truncationLength = 400;
        this.isTruncated =
            props.personalHistory.description &&
            props.personalHistory.description.length > this.truncationLength;

        this.state = {
            isTruncated: this.isTruncated,
        };
    }

    static propTypes = {
        /**
         * list of experiences or educations
         */
        personalHistory: personalHistoryShape.isRequired,
        /**
         * list of raw experiences or educations
         */
        rawPersonalHistoryList: PropTypes.array.isRequired,
        /**
         * addtional styling to override default
         */
        className: PropTypes.string,
        // function to update parent state with updated history list on api call success
        updateHistoryList: PropTypes.func.isRequired,
    };

    static defaultProps = {
        personalHistory: {},
        rawPersonalHistoryList: [],
        className: '',
    };

    static contextType = PageContext;

    handleEditClick = () => {
        const {
            personalHistory,
            rawPersonalHistoryList,
            updateHistoryList,
        } = this.props;
        const { id, type } = personalHistory;
        const { triggerFlowModal } = this.context;

        const rawHistoriesWithId = rawPersonalHistoryList.map((item) => {
            const newId =
                type === 'experience'
                    ? getExperienceId(item)
                    : getEducationId(item);
            return {
                ...item,
                id: newId,
            };
        });

        const historyToEdit = findHistoryById(id, rawHistoriesWithId);

        const stepPopulateKey = `single${capitalize(type)}`; // i.e. singleExperience or singleEducation (step name)
        const generalStepPropKey = `${type}s`; // raw educations or experiences for general modal props

        const rawStepPopulateProps = {
            [stepPopulateKey]: { ...historyToEdit },
        }; // { singleEducation: { id: 123, educationId: 123, field: 'Business' } }

        const stepPopulateProps =
            type === 'experience'
                ? buildDefaultSingleExperienceState(rawStepPopulateProps)
                : buildDefaultSingleEducationState(rawStepPopulateProps);

        const modalData = {
            stepPopulateProps,
            generalModalProps: {
                [generalStepPropKey]: rawHistoriesWithId, // { educations: [{ educationId: 123, id: 123 }, { educationId: 456, id: 456 }] }
                updateHistoryList,
            },
        };

        const flowType =
            type === 'experience'
                ? singleExperienceFlowType
                : singleEducationFlowType;

        return triggerFlowModal(flowType, modalData);
    };

    toggleTruncation = () => {
        this.setState({ isTruncated: !this.state.isTruncated });
    };

    render() {
        const { showEditButton, personalHistory, className } = this.props;

        return (
            <div className={`${this.baseClassName} ${className}`}>
                <div className={`${this.baseClassName}__header`}>
                    <div className={`${this.baseClassName}__header__title`}>
                        {personalHistory.title}
                    </div>

                    {showEditButton && (
                        <EditButton handleClick={this.handleEditClick} />
                    )}
                </div>

                <div className={`${this.baseClassName}__subtitle`}>
                    <span className={`${this.baseClassName}__subtitle__org`}>
                        {personalHistory.organizationName}
                    </span>

                    <span
                        className={`${this.baseClassName}__subtitle__divider`}
                    >
                        {` | `}
                    </span>

                    <span
                        className={`${this.baseClassName}__subtitle__location`}
                    >
                        {personalHistory.location}
                    </span>
                </div>

                {personalHistory.time && (
                    <div className={`${this.baseClassName}__time`}>
                        {personalHistory.time}
                    </div>
                )}

                {personalHistory.description && (
                    <div className={`${this.baseClassName}__description`}>
                        <TruncatableText
                            isDisplayTextTruncated={this.state.isTruncated}
                            displayText={personalHistory.description}
                            handleShowMoreOrLessClick={this.toggleTruncation}
                            showMoreBtnText="More ..."
                            textAfterTruncation=" "
                            truncatedAtIndex={this.truncationLength - 1}
                            showDotsAfterTruncated={false}
                        />
                    </div>
                )}
            </div>
        );
    }
}
